import { useTheme } from "@emotion/react";
import { useContext } from "react";

import backgroundColorContext from "./backgroundColorContext";
import getVisualColor from "./getVisualColor";

export default function useIsSameBackground(color) {
  const theme = useTheme();
  let containerBackgroundColor = useContext(backgroundColorContext);
  let visualColor = getVisualColor(
    containerBackgroundColor,
    theme.getColor(color),
  );
  return visualColor && visualColor === containerBackgroundColor;
}
